import React from 'react';
import { observer } from 'mobx-react';
import { Trail, animated } from 'react-spring';

import Grid from './Grid';
import SizeOption from './SizeOption';

const options = [
  { value: 'small', label: 'Small', image: 'size_1.svg' },
  { value: 'medium', label: 'Medium', image: 'size_2.svg' },
  { value: 'large', label: 'Large', image: 'size_3.svg' },
  { value: 'extra-large', label: 'Extra Large', image: 'size_4.svg' },
];

export default observer(({ size, onChange }) => (
  <Grid>
    <Trail native items={options} from={{ opacity: 0 }} to={{ opacity: 1 }} keys={option => option.value}>
      {option => animation => (
        <animated.div
          style={{
            position: 'relative',
            ...animation,
          }}>
          <SizeOption
            name="size"
            currentValue={size}
            value={option.value}
            onChange={onChange}
            label={option.label}
            image={option.image}
          />
        </animated.div>
      )}
    </Trail>
  </Grid>
));
